// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"InfoBlock_Wrapper__y5qKU","Container":"InfoBlock_Container__oNrm4"};